import { InventoryOrderStatus, type InventoryOrderCarTireQuoteRecord } from '@navio/nsdk';
import { pluralizeWithValue } from 'noddi-util';

/** Ordered from the supplier and not received yet: what a facility expects in a delivery. */
export const EXPECTED_INVENTORY_ORDER_STATUSES: InventoryOrderStatus[] = [
  InventoryOrderStatus.ORDERED_AT_SUPPLIER,
  InventoryOrderStatus.IN_TRANSIT
];

/** Only an order still on its way can be received. */
export const isInventoryOrderExpected = (order: InventoryOrderCarTireQuoteRecord) =>
  EXPECTED_INVENTORY_ORDER_STATUSES.includes(order.status.status.value);

export const getOrderCar = (order: InventoryOrderCarTireQuoteRecord) => order.car ?? order.tireQuote.car;

export const getOrderSeason = (order: InventoryOrderCarTireQuoteRecord) =>
  order.tire.season ?? order.tireQuote.season.value;

export const getOrderCustomer = (order: InventoryOrderCarTireQuoteRecord) =>
  order.tireQuote.userGroup ?? order.customerGroup ?? null;

export const getOrderTireName = (order: InventoryOrderCarTireQuoteRecord): string =>
  `${order.tire.brandName} ${order.tire.modelName}`.trim();

/** "235/55R19 · 4 tires": the size leads, since it is what staff match against the box label. */
export const getOrderTireDetails = (order: InventoryOrderCarTireQuoteRecord): string =>
  [order.tire.dimensions, pluralizeWithValue({ value: order.numTires, word: 'tire' })].filter(Boolean).join(' · ');
